export default __webpack_public_path__ + "static/media/home_basemap_multi_shape@2x.8596840e.png";